import { render, staticRenderFns } from "./SendOpportunityAlerts.vue?vue&type=template&id=f8db1b24&scoped=true"
import script from "./SendOpportunityAlerts.vue?vue&type=script&lang=js"
export * from "./SendOpportunityAlerts.vue?vue&type=script&lang=js"
import style0 from "./SendOpportunityAlerts.vue?vue&type=style&index=0&id=f8db1b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8db1b24",
  null
  
)

export default component.exports